[
 { "id": "Bricks", "title": "Кирпич", "tags": ["MaterialBricks"] },
 { "id": "Metal", "title": "Металл", "tags": ["MaterialMetal"] },
 { "id": "Tile", "title": "Плитка", "tags": ["MaterialTile"] },
 { "id": "Marble", "title": "Мрамор", "tags": ["MaterialMarble"] },
 { "id": "Granite", "title": "Гранит", "tags": ["MaterialGranite"] },
 { "id": "Stone", "title": "Камень", "tags": ["MaterialStone"] },
 { "id": "MaterialPlants", "title": "Растения", "tags": ["MaterialLawn"] },
 { "id": "Ground", "title": "Грунт", "tags": ["MaterialGround"] },
 { "id": "Roof", "title": "Кровля", "tags": ["MaterialRoof"] },
 { "id": "Carpet", "title": "Ковры", "tags": ["MaterialCarpet"] },
 { "id": "Parquet or Laminate", "title": "Паркет и ламинат", "tags": ["MaterialParquetOrLaminate"] },
 { "id": "Wallpapers", "title": "Обои", "tags": ["MaterialWallpaper"] },
 { "id": "Paneling", "title": "Панели", "tags": ["MaterialMoldings"] },
 { "id": "Slats", "title": "Рейки", "tags": ["MaterialSlats"] },
 { "id": "Wood", "title": "Дерево", "tags": ["MaterialWood"] },
 { "id": "Finishes", "title": "Отделка", "tags": ["MaterialFinishes"] },
 { "id": "Leather", "title": "Кожа", "tags": ["MaterialLeather"] },
 { "id": "Rattan", "title": "Ротанг", "tags": ["MaterialRattan"] },
 { "id": "Fabric", "title": "Ткани", "tags": ["MaterialFabric"] },
 { "id": "Photo Wallpaper", "title": "Фотообои", "tags": ["MaterialPhotoWallpaper"] },
 { "id": "Water", "title": "Вода", "tags": ["MaterialWater"] },
 { "id": "Neon", "title": "Неон", "tags": ["MaterialNeon"] },
 { "id": "Glass", "title": "Стекло", "tags": ["MaterialGlass"] },
 { "id": "Sky", "title": "Небо", "tags": ["MaterialSky"] },
 { "id": "Other", "title": "Другое", "tags": ["MaterialOther"] }
]
